import { getCurrentQuery, sendData, getData } from "../../utils.js";
import { dispatchOrderValidate } from "./orderValidation.js";

export function deliveryOrder() {
    const radios = document.querySelectorAll('[name="delivery_way__selector"]');
    if(radios.length === 0) return;
    const dataDisplay = document.querySelectorAll('[data-display]');
    const onDeliveryWaySelected = (radio)=>{
        const dataAttr = radio.dataset.radio;
        dataDisplay.forEach(display=>{
            if(display.dataset.display == dataAttr) {
                display.dataset.state = 'active';
            } else {
                display.dataset.state = 'disabled';
            };
        });
        dispatchOrderValidate();
        // При выборе курьера сразу считаем стоимость (без проверки dropdown)
        if (dataAttr === 'courer') {
            const cityInput = document.querySelector('#find-city-modal');
            const city = cityInput ? cityInput.value : '';
            calculateOrderPrice(city, '137');
        }
    };
    radios.forEach(radio=>{
        radio.addEventListener('change',()=> onDeliveryWaySelected(radio));
        radio.addEventListener('click',()=> onDeliveryWaySelected(radio));
    });
    const addressSelectors = document.querySelectorAll('[name="delivery_address__selector"]');
    if(addressSelectors.length === 0) return;
    addressSelectors.forEach(selector=>{
        selector.addEventListener('click',()=>{
            dispatchOrderValidate();
            calculateOrderPrice(selector.dataset.city, '137');
        });
    });
}

export function calculateOrderPrice(address, tariff_code) {
    const queries = getCurrentQuery();
    let idQuery = null;
    if(queries.length > 0) {
        idQuery = getCurrentQuery()[0].order_id;
    }
    // Для самовывоза используем прежний бэкенд; для CDEK — новый endpoint select-delivery
    const proceed = (res) => {
        const deliveryPrice = document.querySelector('[data-price-order="delivery_price"]');
        const totalPrice = document.querySelector('[data-price-order="total_price"]');

        if (deliveryPrice) deliveryPrice.innerText = `${res.delivery_price}`;
        if (totalPrice) totalPrice.innerText = `${res.total_price}`;

        const loyaltyInput = document.querySelector('#order-loyalty-input');
        const promocode = document.querySelector('[name="promo_code"]');
        const bonusAmountRaw = loyaltyInput && typeof loyaltyInput.value !== 'undefined' ? loyaltyInput.value : 0;
        const bonusAmount = Number(bonusAmountRaw);
        const sendInfo = {
            delivery_price: res.delivery_price,
            bonus_amount: isNaN(bonusAmount) ? 0 : bonusAmount
        };

        if (promocode && promocode.value) sendInfo.promo_code = promocode.value;
        sendData(sendInfo, `/api/order/${getCurrentQuery()[0]?.order_id}/prices/`)
            .then(res=>{
                console.log(res);
                Object.entries(res).forEach(([key, value]) => {
                    const priceOrderItem = document.querySelector(`[data-price-order="${key}"]`);
                    priceOrderItem.innerHTML = value;
                });
            });
    };

    if (tariff_code === 'pickup') {
        const body = { address, tariff_code };
        sendData(body, `/api/order/${idQuery}/calculate-delivery-cost/`).then(proceed);
    } else {
        const url = `/cdek-delivery/select-delivery?address=${encodeURIComponent(address)}&tariff_code=${encodeURIComponent(tariff_code)}`;
        getData(url).then(proceed);
    }
}

// Экспортируем функцию для глобального использования
window.calculateOrderPrice = calculateOrderPrice;